import type { POSTCADAPIResponse } from '@partful/shared-types';
import { useProductInventory } from '@partful/shared/lib/hooks/useProductInventory';
import { productInventoryEndpoints } from '@services/productInventory';
import { useMutation } from '@tanstack/react-query';

export interface UseCreateCADJobVars {
  productName: string;
  accountId: string;
}

export const useCreateCADJob = () => {
  const { getService } = useProductInventory();

  return useMutation<POSTCADAPIResponse, Error, UseCreateCADJobVars>({
    mutationFn: async ({ productName, accountId }) => {
      const productInventoryService = await getService();

      return (
        await productInventoryService.post(`${productInventoryEndpoints.contentProcessing.cad}?account=${accountId}`, {
          productName,
        })
      ).data.payload;
    },
  });
};
